import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, "ALLMYGOLF", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_6 = { class: "navbar-nav" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Game")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Range")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Game Instructions")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/game",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/range",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/instructions",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}